import React, { Component, createRef } from 'react'
import cn from 'classnames'
import { injectIntl } from 'react-intl'
import { Chip, Typography, Paper, Collapse, MenuList } from '@material-ui/core'
import { ArrowDropDown } from '@material-ui/icons'
import isEmpty from 'lodash/isEmpty'
import MenuItem from 'components/override/MaterialUI/MenuItem'
import ArrayHelper from 'helpers/array'
import messages from '../translate'

class AssignChipsList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openOptions: !!props.openOptions,
      ...this.initStateData(props),
    }

    this.assignChipRef = createRef()
  }

  componentDidMount() {
    document.addEventListener(
      'click',
      e => this.onClickAssignChipOutside(e),
      false,
    )
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      e => this.onClickAssignChipOutside(e),
      false,
    )
    this.assignChipRef = null
  }

  shouldComponentUpdate(nextProps) {
    const { groups, users } = this.props
    const { groups: nextGroups, users: nextUsers } = nextProps

    if (groups !== nextGroups || users !== nextUsers) {
      this.setState(this.initStateData(nextProps))

      return false
    }

    return true
  }

  onClickAssignChipOutside = event => {
    const { target } = event
    const { onClose, tasksData } = this.props
    const assignChipRef = this.assignChipRef && this.assignChipRef.current

    if (
      !isEmpty(tasksData) &&
      assignChipRef &&
      target &&
      !assignChipRef.contains(target) &&
      !target.closest('.mj-chip-content')
    ) {
      onClose()
    }
  }

  initStateData = props => {
    const {
      groups,
      users,
      groupsValues,
      usersValues,
      intl: { formatMessage },
    } = props
    const indexedGroupsValues = ArrayHelper.map(groupsValues.toArray(), 'id')
    const indexedUsersValues = ArrayHelper.map(usersValues.toArray(), 'id')
    const selectedValues = []
    const options = []
    const formatValues = (list, initValues, prefix, title) => {
      if (list.size > 0) {
        options.push({
          title,
          key: `${prefix}`,
          isLabel: true,
        })

        list.forEach((item, index) => {
          const data = {
            index,
            prefix,
            selected: false,
            optionIndex: options.length,
            key: `${prefix}_${item.get('id')}`,
            id: item.get('id'),
            name: item.get('name'),
          }

          options.push(data)

          if (Object.prototype.hasOwnProperty.call(initValues, data.id)) {
            data.selected = true
            selectedValues.push(data)
          }
        })
      }
    }

    formatValues(
      groups,
      indexedGroupsValues,
      'group',
      formatMessage(messages.groups),
    )
    formatValues(
      users,
      indexedUsersValues,
      'user',
      formatMessage(messages.users),
    )

    return { options, selectedValues }
  }

  onOpenOptions = () => {
    const { isMultiple, handleListChange, taskId } = this.props

    if (isMultiple) {
      handleListChange(taskId)
    } else {
      this.setState(prevState => ({ openOptions: !prevState.openOptions }))
    }
  }

  onChangeOption = event => {
    const { options, selectedValues } = this.state
    const value = options[event.currentTarget.value]
    value.selected = !value.selected
    const nextSelectedValues = value.selected
      ? [...selectedValues, value]
      : selectedValues.filter(item => item !== value)

    this.setState({ selectedValues: nextSelectedValues }, this.changeFormData)
  }

  onDeleteChip = chipIndex => {
    const { selectedValues } = this.state
    const nextSelectedValues = selectedValues.filter((item, index) => {
      const comparison = index !== chipIndex

      if (!comparison) {
        // eslint-disable-next-line no-param-reassign
        item.selected = false
      }

      return comparison
    })

    this.setState({ selectedValues: nextSelectedValues }, this.changeFormData)
  }

  changeFormData = () => {
    const { taskId, onChange } = this.props
    const { selectedValues } = this.state
    const [userIds, userGroupIds] = selectedValues.reduce(
      (list, { id, prefix }) => {
        const [userIds, userGroupIds] = list

        if (prefix === 'group') {
          userGroupIds.push(id)
        }

        if (prefix === 'user') {
          userIds.push(id)
        }

        return list
      },
      [[], []],
    )

    onChange({
      workflow_task: taskId,
      assigned_users: userIds,
      assigned_user_groups: userGroupIds,
    })
  }

  render() {
    const { openOptions, options, selectedValues } = this.state
    const {
      label,
      taskId,
      activeListId,
      tasksData,
      intl: { formatMessage },
    } = this.props
    const isActiveTask = activeListId === taskId
    const isOpen = (isActiveTask && tasksData[taskId] === 'open') || openOptions

    return (
      <Paper className="mj-chip-list">
        {!!label && <Typography className="mj-chip-title">{label}</Typography>}
        <div ref={isActiveTask ? this.assignChipRef : null}>
          <Paper className="mj-chip-field" onClick={this.onOpenOptions}>
            {!selectedValues.length && (
              <span className="chip-placeholder">
                {formatMessage(messages.chooseAssignees)}...
              </span>
            )}
            {selectedValues.length > 0 &&
              selectedValues.map((value, index) => (
                <Chip
                  key={value.key}
                  label={value.name}
                  className="mj-chip-content"
                  onDelete={() => this.onDeleteChip(index)}
                />
              ))}
            <ArrowDropDown
              className={cn('mj-chip-field-arrow-icon', {
                'arrow-icon-rotate': isOpen,
              })}
            />
          </Paper>
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <MenuList className="mj-chip-option-list">
              {options.map((item, index) =>
                item.isLabel ? (
                  <Typography key={item.key} variant="subtitle1">
                    {item.title}
                  </Typography>
                ) : (
                  <MenuItem
                    key={item.key}
                    value={index}
                    selected={item.selected}
                    onClick={this.onChangeOption}>
                    {item.name}
                  </MenuItem>
                ),
              )}
            </MenuList>
          </Collapse>
        </div>
      </Paper>
    )
  }
}

export default injectIntl(AssignChipsList)
